import searchIcon from "../../../images/search_icon.svg";

import { t, DIR } from "../../../i18n";
const SearchComponent = ({ setSearch }) => {
  return (
    <div className="flex items-center w-full max-w-full sm:max-w-[350px] lg:max-w-[400px] h-12 px-3 py-2 rounded-xl shadow-sm border border-slate-300 bg-card gap-2 hover:border-slate-400 focus-within:border-brand-500 focus-within:ring-2 focus-within:ring-brand-500/30">
      {/* Search Input */}
      <input
        type="text"
        placeholder={t("بحث")}
        aria-label={t("بحث")}
        dir={DIR}
        onChange={(e) => setSearch(e.target.value)} // Update parent state
        className="flex-grow text-right text-slate-800 text-sm md:text-base font-medium outline-none bg-transparent placeholder:text-slate-500"
      />

      {/* Search Icon */}
      <img
        src={searchIcon} // Path to the search icon
        alt=""
        className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-7 lg:h-7"
      />
    </div>
  );
};

export default SearchComponent;
